import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d43b873e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-size-14" }
const _hoisted_2 = { class: "w-full d-flex items-center justify-content-between" }
const _hoisted_3 = { class: "order-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isIndividualOffer && _ctx.isShowAdditionalLabel)
          ? (_openBlock(), _createBlock(_component_Tag, {
              key: 0,
              label: "指名",
              class: "text-primary-dark bg-primary-yellow label-text"
            }))
          : _createCommentVNode("", true),
        _createTextVNode(),
        (_ctx.isLimited && _ctx.isShowAdditionalLabel)
          ? (_openBlock(), _createBlock(_component_Tag, {
              key: 1,
              label: "限定",
              class: "text-primary-dark bg-primary-yellow label-text"
            }))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_Tag, {
          label: _ctx.orderService,
          class: "text-blue border-blue label-text"
        }, null, 8, ["label"]),
        _createTextVNode(),
        _createVNode(_component_Tag, {
          label: _ctx.workCategoryLabel,
          class: "text-blue border-blue label-text"
        }, null, 8, ["label"]),
        _createTextVNode(),
        (_ctx.isCareerOrder)
          ? (_openBlock(), _createBlock(_component_Tag, {
              key: 2,
              label: "説明会",
              class: "text-blue border-blue label-text"
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}